<table class="table" [class.divided]="divided()" [ngStyle]="cssStyle()">
  @if (config().filter) {
  <ui-table-filter
    class="table-head"
    [class.sticky]="config().stickyHeader"
    [config]="config().filter"
    [checkAllValue]="checkAllValue()"
    [checkboxDisabled]="!!config().checkboxDisabled"
    [(filterState)]="filterState"
    (checkAll)="onChangeCheckAll()"
    />
  }

  <tbody class="table-body">
    @if (status() === 'loading') {
      <div class="table-loading" data-testid="table-loading">
        <ui-spinner size="large" [label]="'SHARED.LOADING' | transloco"></ui-spinner>
      </div>
    }

    @else if (status() === 'error') {
      <div class="table-error" data-testid="table-error">
        <ui-inline-svg class="table-error-icon" name="alert-triangle"></ui-inline-svg>
        <h1 class="table-error-title">{{ 'SHARED.ERROR.TITLE' | transloco }}</h1>
        <h1 class="table-error-title">{{ 'SHARED.ERROR.SUBTITLE' | transloco }}</h1>
      </div>
    }

    @else if (data().length > 0) {
      @for (item of data(); track $index) {
        <tr
        class="table-row color-{{ config().background }}"
        [class.selected]="checkedValues() | hasValue: item">
          @if (config().checkbox) {
            <ui-checkbox
              class="table-row-checkbox"
              [value]="checkedValues() | hasValue: item"
              [disabled]="!!config().checkboxDisabled"
              (valueChange)="onChangeUpdateCheckbox(item)"
              >
            </ui-checkbox>
          }

          <ng-container
            [ngTemplateOutlet]="template()"
            [ngTemplateOutletContext]="{ $implicit: item }">
          </ng-container>

          @if (config().rowOptions ?? true) {
            <button
              type="button"
              class="table-row-button"
              [class.open]="currentOption() === item"
              data-testid="row-options-btn"
              (click)="onClickOpenOptions(item)">
              <ui-inline-svg [name]="'more-horizontal'"></ui-inline-svg>
            </button>
          }
        </tr>
      }
    }
    
    @else {
      <div class="table-empty">
        @if (emptyTemplate(); as empty) {
          <ng-container [ngTemplateOutlet]="empty"></ng-container>
        } @else {
          <h1 class="table-empty-title">{{ 'SHARED.EMPTY.TEXT1' | transloco }}</h1>
          <h1 class="table-empty-title">{{ 'SHARED.EMPTY.TEXT2' | transloco }}</h1>
          <ui-button size="large" color="onLight" [secondary]="true">
            {{ 'SHARED.EMPTY.BUTTON' | transloco }}
          </ui-button>
        }
      </div>
    }
  </tbody>
</table>

@let pagination = config().pagination;
@let currentPage = page();

@if (pagination && currentPage && status() !== 'error' && totalCount() > 0) {
  <ui-table-paginator
    [page]="currentPage"
    [totalCount]="totalCount()"
    [pageSizeOptions]="pagination.pageSizeOptions"
    [disabled]="status() === 'loading'"
    (pageChange)="page.set($event)"
  />
}

<div #scroll></div>

